// extracted by mini-css-extract-plugin
export default {"emptyContainer":"emptyDataView_emptyContainer__sGd8I","icon":"emptyDataView_icon__EeNRq","message":"emptyDataView_message__6rWFa"};